<div class="lvi-content">
    <div class="avatar">
        {{ extraOptions.avatar }}
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onSelect()">{{ data.libelle }}</a>
        </div>
        <ul *ngIf="data.type != TypeFiltreChar.TYPE_RUBRIQUE" class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.prestations.detail.filtres.listeFiltres.type'"></strong>
                <span>{{ ('admin.frais.prestations.detail.filtres.listeFiltres.' + data.type) | translate }}</span>
            </li>
        </ul>
    </div>
</div>